/* eslint-disable no-throw-literal */
export const TRANSFER_EVENT_INIT = 'TRANSFER_EVENT_INIT'
export const TRANSFER_EVENT_START = 'TRANSFER_EVENT_START'
export const TRANSFER_EVENT_PROGRESS = 'TRANSFER_EVENT_PROGRESS'
export const TRANSFER_EVENT_COMPLETE = 'TRANSFER_EVENT_COMPLETE'
export const TRANSFER_EVENT_CANCELING = 'TRANSFER_EVENT_CANCELING'
export const TRANSFER_EVENT_CANCELED = 'TRANSFER_EVENT_CANCELED'
// It stopped before it finished: an upload's error, a copy whose connection
// closed before its last message. An upload can be retried (back to START).
export const TRANSFER_EVENT_FAILED = 'TRANSFER_EVENT_FAILED'

export const TRANSFER_TYPE_DOWNLOAD = 'TRANSFER_TYPE_DOWNLOAD'
export const TRANSFER_TYPE_UPLOAD = 'TRANSFER_TYPE_UPLOAD'
export const TRANSFER_TYPE_COPY_NODE = 'TRANSFER_TYPE_COPY_NODE'
export const TRANSFER_TYPE_CREATE_TEMPLATE = 'TRANSFER_TYPE_CREATE_TEMPLATE'

export class UploadBase {
    #callbacks = []

    constructor(id, type, name, gotoPath) {
        this._id = id
        this._type = type
        this._name = name
        this._gotoPath = gotoPath
        
        this._status = TRANSFER_EVENT_INIT

        this._notify = false

        this._note = ''

        this._uploadLoaded = 0
        this._uploadTotal = 0
    }

    get id() {
        return this._id
    }

    get type() {
        return this._type
    }

    get name() {
        return this._name
    }

    get size() {
        return this._file ? this._file.size : 0
    }

    get gotoPath() {
        return this._gotoPath
    }

    get status() {
        return this._status
    }

    get progress() {
        return 0
    }

    get queued() {
        return false
    }

    get notify() {
        return this._notify
    }

    get note() {
        return this._note
    }

    set note(value) {
        this._note = value
    }

    get progress() {
        return this._uploadLoaded ? this._uploadLoaded / this._uploadTotal * 100 : 0
    }

    notifySet() {
        this._notify = true
    }

    notifyClear() {
        this._notify = false
    }

    addEventListener(callback) {
        if (typeof callback !== "function") return;
        this.#callbacks.push(callback)
    }

    removeEventListener(callback) {
        this.#callbacks = this.#callbacks.filter(cb => cb !== callback)
    }

    dispatchEvent(event) {
        this._status = event
        this.#callbacks.forEach(callback => callback(event, this));
    }

    // addEventListener(eventtype, callback) {
    //     if (typeof callback !== "function") return;
    //     if (this.#callbacks[eventtype] === undefined) {
    //     this.#callbacks[eventtype] = []
    //     }
    //     this.#callbacks[eventtype].push(callback)
    // }

    // removeEventListener(eventtype, callback) {
    //     if (this.#callbacks[eventtype]) {
    //         this.#callbacks[eventtype] = this.#callbacks[eventtype].filter(cb => cb !== callback)
    //     }
    // }

    // dispatchEvent(eventtype, detail) {
    //     if (this.#callbacks[eventtype] === undefined) return;
    //     const event = new CustomEvent(eventtype, {detail})
    //     this.#callbacks[eventtype].forEach(callback => callback(event));
    // }
}